import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { 
    FONT_SIZE_XS, 
    BUTTON_LETTER_SPACING, 
    BUTTON_FONT_FAMILY, 
    BUTTON_FONT_WEIGHT, 
    FONT_SIZE_4XS 
} from "../../style/fontSettings";
import { 
    MELOGY_BLACK, 
    MELOGY_WHITE 
} from "../../style/colors";
import { findFarthestColor, } from "../../util/StyleSettingsUtil";

const SettingsContainer = styled.div`
    width: 100%;
    max-width: 960px;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;
    z-index: 1;
`;

const SettingsBackGround = styled.div`
    width: 80%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
`;

const StyleContainers = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;

const StyleContainer = styled.div`
    height: 100%;
    width: 33%;
    background-color: ${({ backgroundColor }) => backgroundColor};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: ${({ hasStyle }) => (hasStyle ? "pointer" : "default")};
`;

const StyleDescription = styled.div`
    height: auto; 
    max-height: 80%;
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    overflow: hidden; 
    padding: 8px;
`;

const StyleDescriptionText = styled.div`
    font-size: clamp(${FONT_SIZE_4XS}, 2vw, ${FONT_SIZE_XS}); 
    font-family: ${BUTTON_FONT_FAMILY};
    font-weight: ${BUTTON_FONT_WEIGHT};
    letter-spacing: ${BUTTON_LETTER_SPACING};
    color: ${({ color }) => (color ? color : "#fff")};
    text-align: center;

    word-break: break-word; 
    white-space: normal;
    overflow-wrap: break-word; 
    display: block;
    width: 100%; 
    padding: 8px;
`;

const styleName = "styleName";

const StyleSelection = ({ styles, setSelectedStyle, setStyleSettingsIsOpen }) => {
    const [stylesInRows, setStylesInRows] = useState([]);
    
    const getStyleTextColor = (style) => {
        const buttonColor = findFarthestColor(getStyleColor(style));
        const color = buttonColor === "white" ? MELOGY_WHITE : MELOGY_BLACK;

        return color;
    }

    useEffect(() => {
        const updatedStylesInRows = [];
        updatedStylesInRows.push(["", "", ""]); // Empty row for spacing

        for (let i = 0; i < styles.length; i += 3) {
            const stylesInRow = [
                styles[i]?.find((item) => item.name === styleName)?.value || "",
                styles[i + 1]?.find((item) => item.name === styleName)?.value || "",
                styles[i + 2]?.find((item) => item.name === styleName)?.value || "",
            ];
            updatedStylesInRows.push(stylesInRow);
        }

        updatedStylesInRows.push(["", "", ""]); // Another empty row for spacing
        setStylesInRows(updatedStylesInRows);
    }, [styles]);

    const getStyleName = (index) => {
        if (styles[index]) {
            const styleName = styles[index]?.find((item) => item.name === "styleName")?.value;

            return styleName || ""; 
        }
        return ""; 
    };

    const getStyleColor = (style) => {
        if (!style) {
            return;
        }

        const colorItem = style.find((item) => item.name === "color");

        if (!colorItem) {
            return;
        }

        return colorItem.value;
    }
    
    return (
        <SettingsContainer>
            <SettingsBackGround>
                <Swiper
                    direction="vertical"
                    spaceBetween={0}
                    slidesPerView={5}
                    grabCursor={true}
                    style={{
                        height: "100%",
                        width: "100%",
                    }}
                >
                    {stylesInRows.map((styleInRow, rowIndex) => (
                        <SwiperSlide key={rowIndex}>
                            <StyleContainers>
                                {styleInRow.map((style, colIndex) => {
                                    const index =
                                        style !== "" ? (rowIndex - 1) * 3 + colIndex : null;
                                    return (
                                        <StyleContainer
                                            key={colIndex}
                                            index={index}
                                            hasStyle={!!style}
                                            onClick={() => {
                                                if (style) {
                                                    setSelectedStyle(styles[index]);
                                                    setStyleSettingsIsOpen(true);
                                                }
                                            }}
                                            backgroundColor={getStyleColor(styles[index])}
                                        >
                                            <StyleDescription>
                                                <StyleDescriptionText color={getStyleTextColor(styles[index])}>
                                                    {getStyleName(index)}
                                                </StyleDescriptionText>
                                            </StyleDescription>
                                        </StyleContainer>
                                    );
                                })}
                            </StyleContainers>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </SettingsBackGround>
        </SettingsContainer>
    );
};

export default StyleSelection;
